import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import { UserRoles } from "../../enums/user/userRoles";
import { User } from "../../types/user";
import { getStoreSuperUsers } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

function sortUsersByName(user1: User, user2: User) {
  return user1.fullName &&
    user2.fullName &&
    (user1.firstName ?? "") < (user2.firstName ?? "")
    ? -1
    : 1;
}

function useStoreSuperUsersQuery(storeId?: string, enabled = true) {
  const defaultStoreId = useStoreId();
  return useQuery<User[]>({
    enabled: enabled && !!(storeId || defaultStoreId),
    queryKey: ["store", "super-users", storeId || defaultStoreId],
    queryFn: async () => await getStoreSuperUsers(storeId || defaultStoreId),
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
  });
}

export const useStoreOwners = (storeId?: string, enabled = true) => {
  const { data: superUsers } = useStoreSuperUsersQuery(storeId, enabled);
  return superUsers
    ?.filter((user) => user.roleId === UserRoles.STOREOWNER)
    .sort(sortUsersByName);
};

export const useCountrySuperUsers = (storeId?: string, enabled = true) => {
  const { data: superUsers } = useStoreSuperUsersQuery(storeId, enabled);
  return superUsers
    ?.filter((user) => user.roleId === UserRoles.COUNTRY_SUPERUSER)
    .sort(sortUsersByName);
};
